module.exports = __webpack_public_path__ + "img/tag-icon.52d28b48.svg";